import React, { useEffect, useState } from 'react';
import { Avatar, Select as AntdSelect, Space } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { useClient } from 'src/contexts/Client/Client';
import { filterApiResponse } from '../../../features/Directory/Beneficiary/utils';
import { DirectoryType } from '../../../features/Demands/types';

export type SelectDirectoryMembersProps = {
  id: string;
  placeholder: string;
  defaultValue: string;
  name: string;
  directory?: DirectoryType;
  disabledSelect?: boolean;
  onChange: (value: string) => void;
};

export const SelectDirectoryMembers: React.FC<SelectDirectoryMembersProps> = ({
  id,
  placeholder,
  defaultValue,
  name,
  directory,
  disabledSelect,
  onChange,
}) => {
  const { get } = useClient();
  const [neighbors, setNeighbors] = useState([]);

  const handleChange = () => {
    directory && onChange(directory?.id);
  };

  useEffect(() => {
    get(`/cards?format=list&roles[]=needer`, (response: any): void => {
      response.data && setNeighbors(filterApiResponse(response));
    });
  }, [get]);

  return (
    <AntdSelect
      showSearch
      placeholder={placeholder}
      size="large"
      id={id}
      onChange={handleChange}
      optionFilterProp="children"
      filterOption={(input, option) => {
        return (
          option?.props.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
        );
      }}
      defaultValue={defaultValue}
      disabled={(directory || disabledSelect) && true}
    >
      {neighbors.map((item: any) => {
        return (
          <AntdSelect.Option
            key={item.id}
            value={item.id}
            label={`${item.neighbor.firstname} ${item.neighbor.lastname}`}
          >
            <Space>
              <Avatar
                size="small"
                src={item.neighbor.avatar?.path}
                icon={<UserOutlined />}
                alt={item.neighbor.avatar?.name}
              />
              {`${item.neighbor.firstname} ${item.neighbor.lastname}`}
            </Space>
          </AntdSelect.Option>
        );
      })}
    </AntdSelect>
  );
};
